import { render } from "./IconElectraTireWidth.vue?vue&type=template&id=c4d9bea0"
import script from "./IconElectraTireWidth.vue?vue&type=script&lang=js"
export * from "./IconElectraTireWidth.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__